export default "__VITE_ASSET__BveGlUvZ__"